import { ethers } from 'ethers';
import { message } from 'antd';
import { setFilters } from '../utils/browserUtils';
import UserServiceApi from '../api/userServiceApi';

export const LOGIN_EXPIRY_KEY = 'wallet_login_expiry';
export const WALLET_ADDRESS_KEY = 'wallet_address';

async function login(data){
    console.log("login")
    let result = await UserServiceApi.userLogin(data)
    console.log(result)
    if(!result.error){
        if(result.result){
            setFilters("token",result.result);
            return true;
        }else {
         return false;
        }
    }
    return false;
}

export const connectWallet = async () => {
  try {
    if (!window.ethereum) {
      message.error('请安装MetaMask钱包');
      return null;
    }

    await window.ethereum.request({ method: 'eth_requestAccounts' });
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    const address = await signer.getAddress();
    
    return address;
  } catch (error) {
    message.error('连接钱包失败');
    return null;
  }
};

export const loginWallet = async () => {
  try {
    const address = await connectWallet();
    if (!address) return null;

    const timestamp = Math.round(Date.now() / 1000);
    const messageStr = `{address:"${address}",timestamp:"${timestamp}"}`;
    
    // 请求签名
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    const signature = await signer.signMessage(messageStr);

    if (!signature) {
      message.error('签名失败');
      return null;
    }

    const data = {
      address:address,
      timestamp:timestamp,
      sign:signature
    }
    const flag = await login(data)
    if(!flag){
      message.error("Login failed,please try again!");
      return null;
    }
    // 存储钱包地址
    localStorage.setItem(WALLET_ADDRESS_KEY, address);

    return {
      address,
      timestamp,
      sign: signature
    };
  } catch (error) {
    console.log('error : ',error);
    message.error('钱包登录失败');
    return null;
  }
};

export const checkLoginStatus = () => {
  const token = localStorage.getItem(WALLET_ADDRESS_KEY);
  return !!token;
};

export const getWalletAddress = () => {
  return localStorage.getItem(WALLET_ADDRESS_KEY);
};

export const formatAddress = (address) => {
  if (!address) return '';
  return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
};

export const logout = () => {
  localStorage.removeItem(LOGIN_EXPIRY_KEY);
  localStorage.removeItem(WALLET_ADDRESS_KEY);
  // UserServiceApi.userLogout();
};

export const removeMetaMaskUserAddress = () => {
    console.log("清除账户缓存")
    window.localStorage.removeItem(WALLET_ADDRESS_KEY)
}
